//# sourceMappingURL=organization.mjs.map
/// <reference types="./organization.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Organization extends $CustomType {
  constructor(id, name, display_name, feature_flags, enabled) {
    super();
    this.id = id;
    this.name = name;
    this.display_name = display_name;
    this.feature_flags = feature_flags;
    this.enabled = enabled;
  }
}
export const Organization$Organization = (id, name, display_name, feature_flags, enabled) =>
  new Organization(id, name, display_name, feature_flags, enabled);
export const Organization$isOrganization = (value) =>
  value instanceof Organization;
export const Organization$Organization$id = (value) => value.id;
export const Organization$Organization$0 = (value) => value.id;
export const Organization$Organization$name = (value) => value.name;
export const Organization$Organization$1 = (value) => value.name;
export const Organization$Organization$display_name = (value) =>
  value.display_name;
export const Organization$Organization$2 = (value) => value.display_name;
export const Organization$Organization$feature_flags = (value) =>
  value.feature_flags;
export const Organization$Organization$3 = (value) => value.feature_flags;
export const Organization$Organization$enabled = (value) => value.enabled;
export const Organization$Organization$4 = (value) => value.enabled;

export class Connection extends $CustomType {
  constructor(connection_id) {
    super();
    this.connection_id = connection_id;
  }
}
export const Connection$Connection = (connection_id) =>
  new Connection(connection_id);
export const Connection$isConnection = (value) => value instanceof Connection;
export const Connection$Connection$connection_id = (value) =>
  value.connection_id;
export const Connection$Connection$0 = (value) => value.connection_id;

export class QualificationMatrix extends $CustomType {}
export const FeatureFlag$QualificationMatrix = () => new QualificationMatrix();
export const FeatureFlag$isQualificationMatrix = (value) =>
  value instanceof QualificationMatrix;

export class Translations extends $CustomType {}
export const FeatureFlag$Translations = () => new Translations();
export const FeatureFlag$isTranslations = (value) =>
  value instanceof Translations;

export class Insights extends $CustomType {}
export const FeatureFlag$Insights = () => new Insights();
export const FeatureFlag$isInsights = (value) => value instanceof Insights;

export class WordSupport extends $CustomType {}
export const FeatureFlag$WordSupport = () => new WordSupport();
export const FeatureFlag$isWordSupport = (value) =>
  value instanceof WordSupport;

export class NarrativeSupport extends $CustomType {}
export const FeatureFlag$NarrativeSupport = () => new NarrativeSupport();
export const FeatureFlag$isNarrativeSupport = (value) =>
  value instanceof NarrativeSupport;

export class AdvancedCopilot extends $CustomType {}
export const FeatureFlag$AdvancedCopilot = () => new AdvancedCopilot();
export const FeatureFlag$isAdvancedCopilot = (value) =>
  value instanceof AdvancedCopilot;

export class AgenticCopilot extends $CustomType {}
export const FeatureFlag$AgenticCopilot = () => new AgenticCopilot();
export const FeatureFlag$isAgenticCopilot = (value) =>
  value instanceof AgenticCopilot;

export class ProjectPlanner extends $CustomType {}
export const FeatureFlag$ProjectPlanner = () => new ProjectPlanner();
export const FeatureFlag$isProjectPlanner = (value) =>
  value instanceof ProjectPlanner;

export class IsSteerlab extends $CustomType {}
export const FeatureFlag$IsSteerlab = () => new IsSteerlab();
export const FeatureFlag$isIsSteerlab = (value) => value instanceof IsSteerlab;

export class AnswerVersion extends $CustomType {}
export const FeatureFlag$AnswerVersion = () => new AnswerVersion();
export const FeatureFlag$isAnswerVersion = (value) =>
  value instanceof AnswerVersion;

export class SpreadsheetSelectorV2 extends $CustomType {}
export const FeatureFlag$SpreadsheetSelectorV2 = () =>
  new SpreadsheetSelectorV2();
export const FeatureFlag$isSpreadsheetSelectorV2 = (value) =>
  value instanceof SpreadsheetSelectorV2;

export class AnswerStyle extends $CustomType {}
export const FeatureFlag$AnswerStyle = () => new AnswerStyle();
export const FeatureFlag$isAnswerStyle = (value) =>
  value instanceof AnswerStyle;

export class WebPageCapture extends $CustomType {}
export const FeatureFlag$WebPageCapture = () => new WebPageCapture();
export const FeatureFlag$isWebPageCapture = (value) =>
  value instanceof WebPageCapture;

export class MultipleLongAnswers extends $CustomType {}
export const FeatureFlag$MultipleLongAnswers = () => new MultipleLongAnswers();
export const FeatureFlag$isMultipleLongAnswers = (value) =>
  value instanceof MultipleLongAnswers;

/**
 * Every flag, in the order the admin console lists them. Kept next to the
 * type so adding a variant without listing it here is a visible omission.
 */
export const all_feature_flags = /* @__PURE__ */ toList([
  /* @__PURE__ */ new QualificationMatrix(),
  /* @__PURE__ */ new Translations(),
  /* @__PURE__ */ new Insights(),
  /* @__PURE__ */ new WordSupport(),
  /* @__PURE__ */ new NarrativeSupport(),
  /* @__PURE__ */ new AdvancedCopilot(),
  /* @__PURE__ */ new AgenticCopilot(),
  /* @__PURE__ */ new ProjectPlanner(),
  /* @__PURE__ */ new IsSteerlab(),
  /* @__PURE__ */ new AnswerVersion(),
  /* @__PURE__ */ new SpreadsheetSelectorV2(),
  /* @__PURE__ */ new AnswerStyle(),
  /* @__PURE__ */ new WebPageCapture(),
  /* @__PURE__ */ new MultipleLongAnswers(),
]);

export function feature_flag_from_string(feature_flag) {
  if (feature_flag === "qualification-matrix") {
    return new Ok(new QualificationMatrix());
  } else if (feature_flag === "translations") {
    return new Ok(new Translations());
  } else if (feature_flag === "insights") {
    return new Ok(new Insights());
  } else if (feature_flag === "word-support") {
    return new Ok(new WordSupport());
  } else if (feature_flag === "narrative-support") {
    return new Ok(new NarrativeSupport());
  } else if (feature_flag === "advanced-copilot") {
    return new Ok(new AdvancedCopilot());
  } else if (feature_flag === "agentic-copilot") {
    return new Ok(new AgenticCopilot());
  } else if (feature_flag === "project-planner") {
    return new Ok(new ProjectPlanner());
  } else if (feature_flag === "is-steerlab") {
    return new Ok(new IsSteerlab());
  } else if (feature_flag === "answer-version") {
    return new Ok(new AnswerVersion());
  } else if (feature_flag === "spreadsheet-selector-v2") {
    return new Ok(new SpreadsheetSelectorV2());
  } else if (feature_flag === "answer-style") {
    return new Ok(new AnswerStyle());
  } else if (feature_flag === "web-page-capture") {
    return new Ok(new WebPageCapture());
  } else if (feature_flag === "multiple-long-answers") {
    return new Ok(new MultipleLongAnswers());
  } else {
    return new Error(undefined);
  }
}

/**
 * Lenient: unknown and retired flags are dropped rather than failing the
 * list, so a flag added server-side does not break an older client.
 */
export function feature_flags_decoder() {
  let _pipe = $decode.list($decode.string);
  return $decode.map(
    _pipe,
    (_capture) => {
      return $list.filter_map(_capture, feature_flag_from_string);
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => {
          return $decode.field(
            "display_name",
            $decode.string,
            (display_name) => {
              return $decode.optional_field(
                "feature_flags",
                toList([]),
                $decrypt.json(feature_flags_decoder()),
                (feature_flags) => {
                  return $decode.optional_field(
                    "enabled",
                    true,
                    $decode.bool,
                    (enabled) => {
                      return $decode.success(
                        new Organization(
                          id,
                          name,
                          display_name,
                          feature_flags,
                          enabled,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function feature_flag_to_string(feature_flag) {
  if (feature_flag instanceof QualificationMatrix) {
    return "qualification-matrix";
  } else if (feature_flag instanceof Translations) {
    return "translations";
  } else if (feature_flag instanceof Insights) {
    return "insights";
  } else if (feature_flag instanceof WordSupport) {
    return "word-support";
  } else if (feature_flag instanceof NarrativeSupport) {
    return "narrative-support";
  } else if (feature_flag instanceof AdvancedCopilot) {
    return "advanced-copilot";
  } else if (feature_flag instanceof AgenticCopilot) {
    return "agentic-copilot";
  } else if (feature_flag instanceof ProjectPlanner) {
    return "project-planner";
  } else if (feature_flag instanceof IsSteerlab) {
    return "is-steerlab";
  } else if (feature_flag instanceof AnswerVersion) {
    return "answer-version";
  } else if (feature_flag instanceof SpreadsheetSelectorV2) {
    return "spreadsheet-selector-v2";
  } else if (feature_flag instanceof AnswerStyle) {
    return "answer-style";
  } else if (feature_flag instanceof WebPageCapture) {
    return "web-page-capture";
  } else {
    return "multiple-long-answers";
  }
}

export function encode_feature_flag(feature_flag) {
  let _pipe = feature_flag;
  let _pipe$1 = feature_flag_to_string(_pipe);
  return $json.string(_pipe$1);
}

export function encode(organization) {
  return $json.object(
    toList([
      ["id", $json.string(organization.id)],
      ["name", $json.string(organization.name)],
      ["display_name", $json.string(organization.display_name)],
      [
        "feature_flags",
        $json.array(organization.feature_flags, encode_feature_flag),
      ],
      ["enabled", $json.bool(organization.enabled)],
    ]),
  );
}

export function connection_decoder() {
  return $decode.field(
    "connection_id",
    $decode.string,
    (connection_id) => { return $decode.success(new Connection(connection_id)); },
  );
}

export function encode_connection(connection) {
  return $json.object(
    toList([["connection_id", $json.string(connection.connection_id)]]),
  );
}

/**
 * Strict: an unknown flag fails. For input that must name a real flag.
 */
export function feature_flag_decoder() {
  return $decode.then$(
    $decode.string,
    (feature_flag) => {
      let $ = feature_flag_from_string(feature_flag);
      if ($ instanceof Ok) {
        let feature_flag$1 = $[0];
        return $decode.success(feature_flag$1);
      } else {
        return $decode.failure(new QualificationMatrix(), "FeatureFlag");
      }
    },
  );
}
